import { Divider, Box, Heading } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FloatingHeadTable } from 'components/Table';
import Tooltip from 'components/Tooltip';
import ExportMenu from 'containers/Reports/shared/ExportMenu';
import useStickyHeader from 'containers/Reports/shared/useStickyHeader';

const ScheduleVsHoursReportTable: React.FC<{ data: any; dateRange: any[] }> = ({ data, dateRange }) => {
  const { t } = useTranslation(['common', 'reports']);
  useStickyHeader();

  const columns = useMemo(
    () => [
      {
        Header: t('common:name'),
        accessor: 'name',
      },
      {
        Header: () => {
          return (
            <div>
              {t('reports:scheduledHours')}
              <Tooltip label={t('reports:includesPublishedShiftAndSubmittedTimeOff')} aria-label="A tooltip">
                <Box
                  background="primary.900"
                  color="white"
                  width="15px"
                  height="15px"
                  ml="2"
                  border="1px solid black"
                  borderRadius="50%"
                  display="inline-flex"
                  justifyContent="center"
                  cursor="pointer"
                  alignItems="center"
                >
                  ?
                </Box>
              </Tooltip>
            </div>
          );
        },
        accessor: 'schedule_hours',
      },
      {
        Header: () => {
          return (
            <div>
              {t('reports:workedHours')}
              <Tooltip
                label={t('reports:includesHoursWorkedPaidBreaksAndSubmittedTimeOffHours')}
                aria-label="A tooltip"
              >
                <Box
                  background="primary.900"
                  color="white"
                  width="15px"
                  height="15px"
                  ml="2"
                  border="1px solid black"
                  borderRadius="50%"
                  display="inline-flex"
                  justifyContent="center"
                  cursor="pointer"
                  alignItems="center"
                >
                  ?
                </Box>
              </Tooltip>
            </div>
          );
        },
        accessor: 'worked_hours',
      },
      {
        Header: t('common:difference'),
        accessor: 'difference',
      },
    ],
    [t]
  );

  return (
    <>
      <Divider my="4" />
      <Box p="4">
        <Heading variant="h2" size="md" fontWeight="semibold" mb="4">
          {t('reports:searchResults')}
        </Heading>
        {data?.payload?.attributes ? (
          <ExportMenu
            attributes={data?.payload?.attributes}
            dateRange={dateRange}
            // displaySettings={data?.payload?.integrations}
          />
        ) : null}
        <FloatingHeadTable columns={columns} data={data?.payload?.users || []} />
      </Box>
    </>
  );
};

export default ScheduleVsHoursReportTable;
